import { render, staticRenderFns } from "./sameRefer.vue?vue&type=template&id=02626782"
import script from "./sameRefer.vue?vue&type=script&lang=js"
export * from "./sameRefer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports